"use strict";

/**
 * Applies confirmed quantities to every cart and minicart copy of a line.
 * Omitting quantityOptions restores an input after a rejected AJAX edit.
 * @param {Object} item - Cart line returned by the server
 * @returns {void}
 */
module.exports = function (item) {
    $(".quantity[data-uuid=\"" + item.UUID + "\"]").each(function () {
        var dropdown = $(this);
        var wrapper = dropdown.siblings(".quantity-input-wrapper");
        var options = item.quantityOptions;
        if (options) {
            dropdown.empty();
            for (var quantity = options.minOrderQuantity; quantity <= options.maxOrderQuantity; quantity++) {
                dropdown.append($("<option>").val(quantity).text(quantity));
            }
            // Keep an existing over-limit basket visible while it is corrected.
            if (item.quantity > options.maxOrderQuantity) {
                dropdown.append($("<option>").val(item.quantity).text(item.quantity));
            }
            wrapper.find(".max-order-qtt").val(options.maxOrderQuantity).attr("value", options.maxOrderQuantity);
        }

        dropdown.val(item.quantity).attr("data-pre-select-qty", item.quantity);
        wrapper.find(".js-quantity-input").val(item.quantity);
        wrapper.find(".js-decrease-quantity-trash").toggleClass("d-none", item.quantity > 1);
        wrapper.find(".js-decrease-quantity-minus").toggleClass("d-none", item.quantity <= 1);
        wrapper.find(".js-increase-quantity").each(function () {
            var button = $(this);
            var max = Number(wrapper.find(".max-order-qtt").attr("value"));
            var prescribedQuantity = Number(button.attr("data-prescripted-quantity"));
            var disabled = item.quantity >= max || (prescribedQuantity > 0 && item.quantity >= prescribedQuantity);
            button.prop("disabled", disabled).toggleClass("disabled", disabled);
        });
    });
};
